<template>
  <!-- 申请开发票 -->
  <div id="Invoicedetail" class="Invoicedetail">
    <div class="InvoicedetailInvoice_cont">
      <div class="invoic_body_cont">
        <el-form :model="form" :rules="rules" ref="Invoicedetailinvoice">
          <div class="plain_invoice">
            <p>电子普通发票信息</p>
            <p></p>
            <el-row style="margin-top:15px;">
              <el-col :span="12">
                <el-form-item label="发票类型：" prop="InvoiType">
                  <span v-if="form.InvoiType == 1">普通发票</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="服务名称：" prop="InvoiCont">
                  <span>{{ form.InvoiCont }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="抬头类型：" prop="LookUpType">
                  <span v-if="form.LookUpType == 1">个人</span>
                  <span v-if="form.LookUpType == 2">单位</span>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 电子发票个人 -->
            <el-row style="position:relative;">
              <el-col :span="12">
                <el-form-item label="发票抬头：" prop="InvoiTitle">
                  <span>{{ form.InvoiTitle }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="InvoTitCompan" style="position:relative;">
              <el-col :span="12">
                <el-form-item label="单位税号：" prop="InvoiNum">
                  <span>{{ form.InvoiNum }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="InvoTitCompan" style="position:relative;">
              <el-col :span="12">
                <el-form-item label="开户行及账号：" prop="InvoiNum">
                  <span>{{ form.vat_bank_account }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="InvoTitCompan" style="position:relative;">
              <el-col :span="12">
                <el-form-item label="地址、电话：" prop="InvoiNum">
                  <span>{{ form.vat_company_address }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="InvoTitCompan" style="position:relative;">
              <el-col :span="12">
                <el-form-item label="备注：" prop="InvoiNum">
                  <span>{{ form.vat_remark }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="plain_invoice">
            <p>收票信息</p>
            <p></p>
            <el-row style="margin-top:15px;margin-left:12px">
              <el-col :span="12" style="width:68%">
                <el-form-item label="总金额：" prop="Sumcount">
                  <span>{{ form.Sumcount }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="position:relative;">
              <el-col :span="10">
                <el-form-item label="电子邮箱：" prop="PerEmail">
                  <span>{{ form.PerEmail }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="10" style="height:40px;line-height:40px;font-size:14px;color:red">
                <span>发票已开，前往邮箱下载电子发票</span>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <!-- 发票订单 -->
      <div class="invoice_orderinfo">
        <div>
          <div class="Order_cont_head">
            <div style="width:300px;text-align:left;">商品</div>
            <div style="width:108px;text-align:center;">价格</div>
            <!-- <div style="width:150px;text-align:center;">订单状态</div> -->
            <!-- <div style="width:154px;text-align:center;">操作</div> -->
          </div>
          <div class="Order_cont_main">
            <li v-for="(item, index) in tableDataList" :key="index">
              <div class="Order_cont_main_head">
                <span>订单号：{{ item.orderNumber }}</span>
                <span class="ceoreeTim">{{ item.createTime }}</span>
              </div>
              <div class="bodymain" v-for="(itemB, index) in item.ordersDetaList" :key="index">
                <div class="table" style="width:300px;">
                  <div class="fl">
                    <img :src="itemB.coverPicture" alt="">
                  </div>
                  <div class="fr">
                    <p style="height:40px;">{{ itemB.courseName }}</p>
                  </div>
                  <div style="clear:both;"></div>
                </div>
                <div class="table" style="width:108px;">
                  <p>{{ itemB.totalFee }}</p>
                  <p class="del">{{ itemB.price }}</p>
                </div>
                <div style="clear:both;"></div>
              </div>
              <div class="body_sum">
                <p>合计：{{ item.totalFee }}</p>
              </div>
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Invoicedetail',
  data() {
    return {
      tableDataList: [],
      // 编辑获取发票信息
      editgetinfo: {},
      // 订单id
      OrderId: '',
      OrderIdB: [],
      // 是否显示资质信息
      QuaiInfo: false,
      // 是否显示收票信息
      TicketInfo: false,
      // 电子发票个人
      InvoTitle: false,
      // 电子发票单位
      InvoTitCompan: false,
      // 发票信息
      form: {
        // 订单编号
        // OrderNum:'',
        // 发票类型
        InvoiType: '1',
        // 服务名称
        InvoiCont: '培训费',
        // 抬头类型
        LookUpType: '1',
        // 发票抬头
        InvoiTitle: '',
        // 单位税号
        InvoiNum: '',
        // 电子邮箱
        PerEmail: '',
        // 总金额
        Sumcount: '',
        // 银行
        vat_bank_account: '',
        // 单位地址
        vat_company_address: '',
        // 备注
        vat_remark: ''
      },
      // 发票类型
      SumInvoiType: [
        {
          name: '普通发票',
          id: '1'
        },
      ],
      // 抬头类型
      LookUpType: [
        {
          name: '个人',
          id: '1'
        },
        {
          name: '单位',
          id: '2'
        }
      ],
      rules: {
      },
      checkout: false,
    }
  },
  methods: {
    // 获取发票信息
    getInvoiceInfo() {
      this.httphelper.post('/api/InvoiceApi/GetInvoiceDetailsInfo', {
        userId: this.AuthorId,
        id: Number(this.$route.query.id)
      }).then((res) => {
        // 发票类型
        this.form.InvoiType = String(res.data.data.invoiceType)
        // 服务名称
        // this.form.InvoiCont = res.data.data.serviceName
        // 抬头类型
        this.form.LookUpType = String(res.data.data.iHerdType)
        if (this.form.LookUpType == 2) {
          this.InvoTitCompan = true
        }
        // 发票抬头
        this.form.InvoiTitle = res.data.data.invoiceHerd
        // 单位税号
        this.form.InvoiNum = res.data.data.unitNumber
        // 总金额
        this.form.Sumcount = res.data.data.totalAmount
        // 电子邮箱
        this.form.PerEmail = res.data.data.iEmil
        if (res.data.data.vat_bank_account != null) {
          this.form.vat_bank_account = res.data.data.vat_bank_account
        }
        if (res.data.data.vat_company_address != null) {
          this.form.vat_company_address = res.data.data.vat_company_address
        }
        if (res.data.data.vat_remark != null) {
          this.form.vat_remark = res.data.data.vat_remark
        }
      })
    },
    // 获取发票订单信息
    getInvoiceorderInfo() {
      this.httphelper.post('/api/InvoiceApi/GetUserInvoiceInfoOrdes', {
        userId: this.AuthorId,
        id: Number(this.$route.query.id)
      }).then((res) => {
        this.tableDataList = res.data.data
      })
    }
  },
  created() {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
    }
    this.getInvoiceInfo()
    this.getInvoiceorderInfo()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form {
  width: 88%;
  margin: 0 auto;

  .el-col-12 {
    width: 66%;

    .el-form-item {
      margin-bottom: 13px;
    }

    .el-select {
      width: 64%;

      .el-input {
        width: 100%;
      }
    }

    .el-input {
      width: 64%;
    }
  }
}

.InvoicedetailInvoice_cont {
  position: relative;
  padding: 10px 16px 20px 16px;

  .invoic_body_cont {
    width: 100%;

    .plain_invoice {
      margin-top: 20px;

      p {
        position: relative;
        left: -24px;
      }

      p:nth-child(2) {
        margin-top: 15px;
        width: 80%;
        border-top: 1px dotted #ccc;
      }
    }
  }

  .formBtn {
    width: 105px;
    height: 37px;
    background: #e00019;
    border-radius: 4px;
    text-align: center;
    line-height: 37px;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
    margin-top: 22px;
    margin-left: 83px;
  }

  .Order_cont_head {
    width: 94%;
    height: 75px;
    line-height: 75px;
    padding: 0 26px 0 26px;
    border-top: 1px solid #eceef2;
    margin-top: 13px;

    div {
      display: inline-block;
    }
  }

  .Order_cont_main {
    width: 100%;
    height: auto;
    border-bottom: 1px solid #eceef2;

    li {
      width: 100%;
      list-style: none;

      .Order_cont_main_head {
        width: 748px;
        height: 32px;
        background: #f8f9fa;
        border: 1px solid #eceef2;
        padding-left: 13px;

        span {
          color: #959595;
          line-height: 35px;
          font-size: 12px;
        }

        .ceoreeTim {
          margin-left: 50px;
        }
      }

      .bodymain {
        padding: 15px 26px 15px 26px;
        border-bottom: 1px solid #eceef2;

        .table {
          float: left;
          margin-left: 5px;
          // height: 68px;
        }

        .table:nth-child(1) {
          margin-left: 0px;

          .fl {
            width: 98px;
            height: 58px;
            margin-top: 5px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .fr {
            width: 60%;

            p:nth-child(1) {
              width: 90%;
              color: #434343;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-top: 14px;
            }
          }
        }
        .table:nth-child(3) {
          p {
            text-align: center;
            line-height: 60px;
            font-size: 14px;
            color: #838383;
          }
        }

        .table:nth-child(2) {
          p {
            text-align: center;
            color: #838383;
            font-size: 14px;
            margin-top: 10px;
          }
        }

        .table:nth-child(4) {
          p {
            float: left;
          }

          p:nth-child(1) {
            color: #838383;
            font-size: 14px;
            line-height: 60px;
            cursor: pointer;
            margin-left: 11px;
          }

          p:nth-child(1):hover {
            text-decoration: underline;
          }

          p:nth-child(2) {
            width: 60px;
            height: 26px;
            border: 1px solid #e0001a;
            text-align: center;
            line-height: 26px;
            color: #ff0001;
            font-size: 14px;
            border-radius: 4px;
            margin-left: 23px;
            margin-top: 15px;
            cursor: pointer;
          }
        }
      }

      .body_sum {
        width: 100%;
        height: 50px;
        line-height: 50px;

        p {
          float: left;
        }

        p:nth-child(1) {
          color: #444444;
          font-size: 14px;
          margin-left: 493px;
        }

        .delorder:hover {
          text-decoration: underline;
        }

        .delorder,
        .applyorder {
          display: inline-block;
          width: 60px;
          height: 26px;
          border: 1px solid #e0001a;
          text-align: center;
          line-height: 26px;
          color: #ff0001;
          font-size: 14px;
          border-radius: 4px;
          margin-top: 12px;
          cursor: pointer;
        }

        .delorder {
          margin-left: 35px;
          color: #838383;
          border: none;
        }

        .applyorder {
          margin-left: 35px;
        }
      }
    }
  }
}
</style>
